export default __webpack_public_path__ + "static/media/arena-destacado.182c6be1.png";